import TagManager from 'react-gtm-module';

export const sendEvent = (event, value) => {
    const tagManagerArgs = {
        dataLayer: {
            [event]: value,
        },
    };
    
    TagManager.dataLayer(tagManagerArgs)
};

export const sendCustomEvent = (event, key, value) => {
    const tagManagerArgs = {
        dataLayer: {
            event,
            category: 'ReachOut',
            [key]: value,
        },
    };
    
    TagManager.dataLayer(tagManagerArgs)
};

// GA4's User-ID, handed straight to the Google tag GTM loads (it reads this same dataLayer).
// A gtag `set` applies to every hit after it without reconfiguring the tag, which GA4 would
// ignore as a duplicate. `undefined` clears it; `null` does not.
export const setUserId = (id) => {
    window.dataLayer = window.dataLayer || [];
    // gtag commands are read from the `arguments` object, not from an array.
    // eslint-disable-next-line prefer-rest-params
    (function gtag() { window.dataLayer.push(arguments); })('set', { user_id: id || undefined });
};

const e = {
    sendEvent,
    sendCustomEvent,
    setUserId,
};

export default e;
